import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Warehouse } from '../../shared/models/warehouse.interface';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { WarehouseLocation } from '../../shared/models/warehouse.location.interface';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.scss']
})
export class WarehouseComponent implements OnInit {

  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<WarehouseComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  warehouse: Warehouse;

  states: string[];
  errors: string;
  isRequesting: boolean;
  newlocCount = 0;
  rowIndex = 0;

  ngOnInit() {
    let warehouseId: number = this.data.id;

    if (warehouseId == null) {
      this.warehouse = {} as Warehouse;
      this.warehouse.warehouse_IsActive = true;
    }
    else {
      this.adminService.getWarehouse(warehouseId)
        .subscribe({
          next: (data) => {
            this.warehouse = data;
          }
        })
    }

    this.adminService.getStates()
      .subscribe({
        next: (data) => {
          this.states = data;
        }
      })
  }

  saveWarehouse(form: NgForm, addLocation: boolean) {
    //this.setFullLocationInfo();
    console.log('in warehouse onSubmit: ', this.warehouse);
    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();
      this.warehouse.dealer_ID = dealerId;

      this.adminService.saveWarehouse(this.warehouse)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result && !addLocation) {
              this.dialogRef.close();
            }
            else {
              this.warehouse = result;
              if (!this.warehouse.warehouseLocations) {
              }
            }
          },
          error: (error: string) => this.errors = error
        });
    }
  }

  addLocation(form: NgForm) {
    this.newlocCount++;
    let newLocation = {
      dealer_ID: this.warehouse.dealer_ID,
      warehouse_ID: this.warehouse.warehouse_ID,
      warehouseLocation_Name: null,
      warehouseLocation_Row: null,
      warehouseLocation_Shelf: null,
      warehouseLocation_Bin: null,
      warehouseLocation_IsActive: true
    } as WarehouseLocation;
    this.warehouse.warehouseLocations.push(newLocation)
  }

  deleteLocation(rowtoDeleteIndex: number) {
    this.warehouse.warehouseLocations.splice(rowtoDeleteIndex, 1);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  setFullLocationInfo() {
    this.warehouse.warehouseLocations.forEach(function (value) {
      if (value.warehouseLocation_ID == null) {
        value.warehouseLocation_FullLocation = `${value.warehouseLocation_Row} - ${value.warehouseLocation_Shelf} - ${value.warehouseLocation_Bin}`; 
      }
    });
  }

}
